
(function(){
  /* One instance per document. If a second copy is ever rendered its script
     exits here rather than binding a duplicate set of document listeners. */
  if (window.__lafsContactInit) return;
  window.__lafsContactInit = true;

  var ov = document.getElementById('lct-ov');
  if (!ov) return;
  var box = ov.querySelector('.lct-box');
  var lastFocus = null;
  var SEL = 'a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function focusables(){
    return Array.prototype.filter.call(box.querySelectorAll(SEL), function(el){
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function open(sourceLabel){
    if (ov.classList.contains('lct-on')) return;
    var src = document.getElementById('lct-src');
    if (src && sourceLabel) src.value = sourceLabel;
    lastFocus = document.activeElement;
    ov.hidden = false;
    requestAnimationFrame(function(){ ov.classList.add('lct-on'); });
    document.documentElement.style.overflow = 'hidden';
    var first = box.querySelector('input,textarea') || document.getElementById('lct-x');
    if (first) setTimeout(function(){ try { first.focus(); } catch(e){} }, 80);
  }

  function close(){
    if (!ov.classList.contains('lct-on')) return;
    ov.classList.remove('lct-on');
    document.documentElement.style.overflow = '';
    setTimeout(function(){ if (!ov.classList.contains('lct-on')) ov.hidden = true; }, 240);
    if (lastFocus) { try { lastFocus.focus(); } catch(e){} }
  }

  window.lafsContact = open;

  /* Capture phase, and registered before the enrollment modal's own delegate,
     so a data-lafs-contact trigger is claimed here and never double-handled. */
  document.addEventListener('click', function(e){
    if (ov.contains(e.target)) {
      var t = e.target;
      var onX = t.id === 'lct-x' || (t.closest && t.closest('#lct-x'));
      var onScrim = t === ov || (t.classList && t.classList.contains('lct-pos'));
      if (onX || onScrim) { e.preventDefault(); close(); }
      return;
    }
    var el = e.target;
    for (var i = 0; i < 5 && el && el !== document.body; i++) {
      if (el.nodeType === 1 &&
          (el.hasAttribute('data-lafs-contact') ||
           (el.tagName === 'A' && (el.getAttribute('href') || '') === '#contact'))) {
        e.preventDefault();
        e.stopPropagation();
        var label = (el.getAttribute('data-lafs-contact') || '') ||
                    (document.title + ' — ' + window.location.pathname);
        open(label);
        return;
      }
      el = el.parentNode;
    }
  }, true);

  /* Escape closes; Tab is trapped inside the dialog while it is open. */
  document.addEventListener('keydown', function(e){
    if (!ov.classList.contains('lct-on')) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !box.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }, true);

  /* Remember that THIS form was the one submitted, so the thank-you only
     reopens the modal the visitor actually used. */
  var f = document.getElementById('lafs-contact-form');
  if (f) f.addEventListener('submit', function(){
    try { sessionStorage.setItem('lafsContactSent', '1'); } catch(err){}
  });

  /* Shopify redirects back with ?contact_posted=true. If the flag says the post
     came from here, strip the parameter before any later-rendered modal sees it
     — otherwise the enrollment modal would pop open over our thank-you. */
  try {
    if (sessionStorage.getItem('lafsContactSent') === '1' &&
        window.location.search.indexOf('contact_posted=true') > -1) {
      sessionStorage.removeItem('lafsContactSent');
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname + window.location.hash);
      }
      open('');
    }
  } catch(err){}
})();
